// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__VUE3v","burger":"Navigation_burger__uloCM","userData":"Navigation_userData__yTsHn"};